import { render, staticRenderFns } from "./Autos.vue?vue&type=template&id=28b03f0c"
import script from "./Autos.vue?vue&type=script&lang=js"
export * from "./Autos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports